const JOB_BOARD_ORG_ID_PREFIXES = ["332"];

export function isJobBoardOrganization(orgId) {
	const normalizedOrgId = String(orgId || "").trim().toLowerCase();
	return JOB_BOARD_ORG_ID_PREFIXES.some(prefix => normalizedOrgId.indexOf(prefix) === 0);
}

export function getStatusPanelLabel(orgId) {
	return isJobBoardOrganization(orgId) ? "Job Board" : "Status";
}
